// Order status pill. Wording comes from the shared vocabulary (lib/labels.js): staff see the workflow
// state ("Awaiting approval"), clients and reps see what it means for them ("Being reviewed").
import { useAuthStore } from '../stores/authStore.js';
import { orderStatusLabel } from '../lib/labels.js';

const TONE = {
  APPROVED: ['bg-success-light', 'text-success'],
  PENDING_APPROVAL: ['bg-warning-light', 'text-warning'],
  REJECTED: ['bg-error-light', 'text-error'],
  DRAFT: ['bg-surface-raised', 'text-text-muted'],
  CANCELLED: ['bg-surface-raised', 'text-text-muted'],
};

export default function StatusBadge({ status, role: roleProp }) {
  const viewerRole = useAuthStore((s) => s.user?.role);
  const [bg, fg] = TONE[status] || ['bg-surface-raised', 'text-text-muted'];
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${bg} ${fg}`}>
      {orderStatusLabel(status, roleProp || viewerRole)}
    </span>
  );
}
